import { addSpacing } from '@/utils/utils';
import { textBoxStyling } from 'components/forms/new/formStyles';

// PlatformUserTypeExtendedAttribute.attributeType
export const EXTENDED_ATTRIBUTE_TYPE = {
    BOOLEAN: 0,
    INT: 1,
    GUID: 2,
    TEXT: 3,
    LIST: 4,
    NUMERIC: 5,
    RANDOM: 6,
};

// Random attributes and anything named "*pin*" are masked but still editable.
export const isMaskedAttribute = (attributeName, attributeType) =>
    attributeType === EXTENDED_ATTRIBUTE_TYPE.RANDOM ||
    /pin/i.test(attributeName || '');

// Friendly labels for List values per the ADO #2590 design; unmapped values fall back to spaced-out raw text.
export const LIST_VALUE_LABELS = {
    InboundCallerIdFormat: {
        RGNAME_CALLERNUMBER: "Ring Group Name and Caller's Number",
        CALLERNAME_CALLERNUMBER: "Caller's Name and Caller's Number",
        RGNAME_RGEXTENSION: 'Ring Group Name and Ring Group Extension',
        RGNAME_DIALEDNUMBER: 'Ring Group Name and Dialed Number',
    },
    RingPattern: {
        SIMULTANEOUS: 'Simultaneous',
        ROUND_ROBIN: 'Round Robin (Cyclic)',
        SEQUENTIAL: 'Sequential (Cyclic Repetitive)',
    },
    VoiceMailNotificationAction: {
        DISABLE: 'Disable',
    },
};

// Fields with their own dedicated control, or not useful to show generically below.
export const HIDDEN_FIELDS = new Set([
    'voiceMailAccessEnabled',
    'parentUserID',
    'memberUserID',
]);

export const ringGroupQK = 'ringgroup-member-detail';

// Shared width so every field type (Input, Select, NumberField) lines up in this accordion.
export const FIELD_WIDTH = '442px';
export const fieldInputStyling = { ...textBoxStyling, width: FIELD_WIDTH };

// "From 1-10" range helper text; a fixed-length field reads as "Must be 9" instead of "From 9-9".
export const getRangeHelperText = (attribute, unit = '') => {
    const { minimum, maximum } = attribute;
    const suffix = unit ? ` ${unit}` : '';
    if (minimum == null && maximum == null) return null;
    if (minimum != null && maximum != null) {
        return minimum === maximum
            ? `Must be ${minimum}${suffix}`
            : `From ${minimum}-${maximum}${suffix}`;
    }
    return minimum != null
        ? `Minimum ${minimum}${suffix}`
        : `Maximum ${maximum}${suffix}`;
};

export const getListOptionLabel = (attributeName, value) =>
    LIST_VALUE_LABELS[attributeName]?.[value] || addSpacing(value) || value;

// A "list" attribute's validValues is a single comma-separated string of legal choices.
export const getListOptions = (attribute) =>
    String(attribute.validValues || '')
        .split(',')
        .map((v) => v.trim())
        .filter(Boolean)
        .map((v) => ({
            value: v,
            label: getListOptionLabel(attribute.attributeName, v),
        }));
